// src/pages/LoginPage.js

import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { FaEye, FaEyeSlash } from "react-icons/fa";

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { login, isLoading, setIsLoading } = useContext(AuthContext);
    const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        login({ email, password });
    };

    return (
        <>
            <div className="content-login container d-flex justify-content-center align-items-center">
                <div
                    className="card shadow-lg p-4 w-100"
                    style={{
                        maxWidth: "400px",
                        borderRadius: "15px",
                        backgroundColor: "#ffffffc7",
                    }}
                >
                    <div className="text-center mb-4">
                        <div className="content-logo">
                            <img src="/logo.png" alt="Logo" className="animated-logo" />
                        </div>
                        <h3 className="fw-bold">Bienvenue sur Net Track!</h3>
                        <p className="text-muted">Connectez-vous pour continuer</p>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label fw-bold">Email</label>
                            <input
                                type="email"
                                className="form-control"
                                id="email"
                                placeholder="Entrez votre email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-3 position-relative">
                            <label htmlFor="password" className="form-label fw-bold">Mot de passe</label>
                            <input
                                type={showPassword ? "text" : "password"}
                                className="form-control pe-5"
                                id="password"
                                placeholder="Entrez votre mot de passe"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: "absolute",
                                    top: "70%",
                                    right: "15px",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#555",
                                    zIndex: 2
                                }}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>

                        <button type="submit" className="btn btn-primary w-100 fw-bold" disabled={isLoading}>
                            {isLoading ? <span className="spinner-border spinner-border-sm" role="status"></span> : 'Se connecter'}
                        </button>
                    </form>
                </div>
            </div>

            <style>{`
                .content-login {
                    background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,121,109,1) 50%, rgba(0,212,255,1) 100%);
                    height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-width: 100%;
                }
                .content-logo {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 71px;
                    height: 71px;
                    border-radius: 50%;
                    background-color: #fff;
                    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
                    margin: auto;
                    padding: 10px;
                    animation: bounceScale 2s infinite ease-in-out;
                }
                .animated-logo {
                    width: 80px;
                    height: 80px; 
                }
                @keyframes bounceScale {
                    0%, 100% {
                        transform: translateY(0);
                    }
                    50% {
                        transform: translateY(-10px);
                    }
                }
                .text-muted {
                    color: #ffffff !important;
                }
                @media (max-width: 400px) {
                    .card {
                        padding: 20px 15px !important;
                    }

                    .animated-logo {
                        width: 60px;
                        height: 60px;
                    }
                }
            `}</style>
        </>

    );
};

export default LoginPage;
